
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useRef, useImperativeHandle, useEffect, useState } from 'react';
import { PrimaryDrawer } from "../Drawer/PrimaryDrawer";
import { Format1, Format2 } from "./Templates";
import clsx from "clsx";
import { Space, Row, Col } from "antd";
import { Button } from "@mui/material";
import jsPDF from 'jspdf';
import { CustomSelect } from "../CustomSelect";
import { MediumFont, NormalFont } from "../font";
import html2canvas from "html2canvas";
import { pix2mm, getFileAsJson, checkDocumentPosView, storageSetItem } from "../../../../helpers/utilities";
// import ReactPrint from 'react-to-print';
import { useReactToPrint } from 'react-to-print';


const SalesModal = React.forwardRef((props, ref) => {
    const { visible, classes, handleClose, details } = props;
    const pdfExportComponent = useRef(null);
    const [logo, setLogo] = useState('');
    const [qrCode, setQrCode] = useState('');
    const [showNameDesc, setShowNameDesc] = useState(checkDocumentPosView());

    const handleCustomDownload = (type = 'download') => {
        //    const content = pdfExportComponent.current;
        //     const doc = new jsPDF('pt', 'mm', [80, pix2mm(document.getElementById("thprintdetails").clientHeight - 70, 203)], true);
        //     doc.addFileToVFS('Roboto-Regular.ttf', NormalFont);
        //     doc.addFont('Roboto-Regular.ttf', 'Roboto', 'normal');
        //     doc.addFileToVFS('Roboto-Medium.ttf', MediumFont);
        //     doc.addFont('Roboto-Medium.ttf', 'RobotoMedium', 'normal');
        //     doc.setFont("Roboto");
        //     doc.setFont("RobotoMedium");
        //     doc.html(content, {
        //         callback: function (doc) {
        //             // if (process.env.NODE_ENV === 'development' || process.env.REACT_APP_PRODUCTION_MODE === 'development' || process.env.REACT_APP_PRODUCTION_MODE === 'qa') {
        //             //     doc.addImage(Artboard, 'PNG', 100, doc.internal.pageSize.height - 275, 400, 54, '', '', 45);
        //             // }
        //             if (type === 'print') {
        //                 doc.autoPrint();
        //                 window.open(doc.output('bloburl'));
        //             } else {
        //                 doc.save(`Sales-${props?.details?.cashReceiptNumber}`);
        //             }
        //         },
        //         autoPaging: 'text',
        //         margin: 0,
        //         html2canvas: { scale: 0.3 } // change the scale to whatever number you need
        //     });

        //  const pdf = new jsPDF("pt", "mm", [80, pix2mm(document.getElementById("thprintdetails").clientHeight, 300)]);
        if (document?.getElementById("thprintdetails") === null) {
            return;
        }
        const pdf = new jsPDF("pt", "mm", [80, pix2mm(document?.getElementById("thprintdetails").clientHeight - 70, 300)]);
        pdf.addFileToVFS('Roboto-Regular.ttf', NormalFont);
        pdf.addFont('Roboto-Regular.ttf', 'Roboto', 'normal');
        pdf.addFileToVFS('Roboto-Medium.ttf', MediumFont);
        pdf.addFont('Roboto-Medium.ttf', 'RobotoMedium', 'normal');
        pdf.setFont("Roboto");
        pdf.setFont("RobotoMedium");
        const input = document.getElementById("thprintdetails");
        var margin = 5;
        html2canvas(input, { scale: 2 }).then((canvas) => {
            const imgData = canvas.toDataURL("image/png");
            const imgProps = pdf.getImageProperties(imgData);
            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
            pdf.addImage(imgData, 'PNG', margin, margin, pdfWidth - (margin * 2), pdfHeight - (margin * 2));
            if (type === 'print') {
                // Convert to blob correctly
                const blob = pdf.output("blob");
                const formData = new FormData();
                formData.append("mode", "file");
                formData.append("type", "storeSales");
                formData.append("details", JSON.stringify(details));

                formData.append("file", blob, "file.pdf");
                fetch(process.env.REACT_APP_EXE_CONNECT_URL, {
                    method: "POST",
                    body: formData
                }).then((res) => res.json()).then((data) => {
                    console.log("Print server response:", data);
                }).catch((err) => { handlePrint(); console.error("Print error:", err) });
            } else {
                pdf.save(`Sales-${props?.details?.cashReceiptNumber || ''}`);
            }
        });
    };

    useEffect(() => {
        if (details?.business?.logoUri) {
            fetch(getFileAsJson(details?.business?.logoUri))
                .then(response => response.json())
                .then(data => {
                    // Handle the fetched data here
                    if (data?.contentType) {
                        setLogo('data:' + data?.contentType + ';base64,' + data?.data);
                        handleDownload('print', true);
                    }
                })
                .catch(error => {
                    // Handle any errors
                });
        } else {
            handleDownload('print', true);
        }
    }, []);

    useEffect(() => {
        if (details?.business?.storeSalesQrCodeUri) {
            fetch(getFileAsJson(details?.business?.storeSalesQrCodeUri))
                .then(response => response.json())
                .then(data => {
                    // Handle the fetched data here
                    if (data?.contentType) {
                        setQrCode('data:' + data?.contentType + ';base64,' + data?.data);
                        handleDownload('print', true);
                    }
                })
                .catch(error => {
                    // Handle any errors
                });
        } else {
            handleDownload('print', true);
        }
    }, []);

    const handleDownload = async (type = 'download') => {
        handleCustomDownload(type);
        // try {
        //     if (storageGetItem('qzTray') === 'installed') {
        //         await qz.websocket.connect();
        //         const defaultPrinter = await qz.printers.getDefault();
        //         var printerName = type === 'download' ? "PDF" : defaultPrinter;
        //         const config = qz.configs.create(printerName, {
        //             // "size": { width: 80, height: 200 }, // Set paper size as needed
        //             "margin": { top: 5, bottom: 5, left: 5, right: 5 }
        //         });
        //         await qz.print(config, [
        //             {
        //                 type: 'pixel',
        //                 format: 'html',
        //                 flavor: 'plain',
        //                 data: document.getElementById("thprintdetails").innerHTML,
        //             },
        //         ]);
        //         await qz.websocket.disconnect();
        //     } else {
        //         if (type === 'download') {
        //             handleCustomDownload();
        //         } else {
        //             handlePrint();
        //         }
        //     }
        // } catch (err) {
        //     console.log(err);
        // }
    }

    const handleDisplayName = (data) => {
        storageSetItem('documentPosView', data);
        setShowNameDesc(data);
    }

    const handlePrint = useReactToPrint({
        content: () => document.getElementById("thprintdetails"),
    });

    useImperativeHandle(ref, () => ({
        handleDownload(type) {
            handleDownload(type)
        },
        handlePrint() {
            handleDownload('print')
        }
    }))

    const previewFormat = (format) => {
        switch (format) {
            case "format1": return <Format1 clsx={clsx} logo={logo} qrCode={qrCode} showNameDesc={showNameDesc} {...props} />;
            case "format2": return <Format2 clsx={clsx} logo={logo} qrCode={qrCode} showNameDesc={showNameDesc} {...props} />;
            default: return <Format1 clsx={clsx} logo={logo} qrCode={qrCode} showNameDesc={showNameDesc} {...props} />;
        }
    }

    return (
        <PrimaryDrawer
            anchor={'right'}
            open={visible}
            variant={'temporary'}
            handleClose={() => handleClose()}
            title={'Print View'}
            className={classes.closeBackGround}
            component={
                <div className={clsx(classes.customForm, classes.removeUnderline)}>
                    <Row className={classes.invoiceHeader}>
                        <Col span={12}>
                            <CustomSelect
                                lableClasses={clsx(classes.textFieldLableColorCustom)}
                                customClasses={clsx(classes.dropDownHighlight, classes.dropDownPointer)}
                                details={[{ id: 'name', name: 'Name' }, { id: 'description', name: 'Description' }]}
                                onChange={(e) => handleDisplayName(e.target.value)}
                                defaultValue={showNameDesc}
                                heads={['id', 'name']}
                            />
                        </Col>
                    </Row>

                    <div ref={pdfExportComponent} style={{ fontFamily: "Roboto", display: "block" }} id={"divToPrint"} className={classes.customFormFlex}>
                        {previewFormat(props?.details?.billFormat || 'format1')}
                    </div>
                    <div className={clsx(classes.btnParent)}>
                        <Space direction="horizontal" align="center" size={[10, 10]}>
                            <Button key="Print"
                                color='primary'
                                variant="contained" onClick={() => handleDownload('print')} className={clsx(classes.modalBtn)}>Print</Button>
                            {/* <ReactPrint trigger={() => <Button key="Print"
                                color='primary'
                                variant="contained" className={clsx(classes.modalBtn)}>Print</Button>} content={() => document.getElementById("thprintdetails")} documentTitle={`Sales-${props?.details?.cashReceiptNumber}`} /> */}
                            {/* <Button
                                key="Print"
                                color='primary'
                                variant="contained"
                                onClick={() => handleDownload('print')}
                                className={clsx(classes.modalBtn)}> Print</Button>
                            <Button
                                key="Print"
                                color='primary'
                                variant="contained"
                                onClick={() => handleDownloadAnk('print')}
                                className={clsx(classes.modalBtn)}> Print ANK</Button> */}
                            <Button
                                key="Download"
                                color='primary'
                                variant="contained"
                                onClick={() => handleDownload()}
                                className={clsx(classes.AddMoreBtn)}>Download</Button>
                        </Space>
                    </div>
                </div>
            }
        />
    )
});

export default SalesModal;